import { SessionService } from "./session"

/// <reference path="session.ts" />

export function setupSession(module: ng.IModule) {

    module.service("OmniaSession", SessionService)
}
